import React from 'react'
import Error404 from '../../Pages/Error404'
import Navbar from '../Navbar'


const Error = () => {
    return (
        <div>
            <Navbar/>
            <Error404/>
        </div>
    )
}

export default Error
